import React, { useEffect } from "react";
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setUpHeader } from "../store/features/slice-ui";
import { ReactComponent as Logo } from '../assets/images/logo.svg';
import Button from '../components/Button';

// Flexible Modules
import FlexibleVideo from '../components/flexible/Video';
import FlexibleList from '../components/flexible/List/List';
// import FlexibleAccordion from '../components/flexible/Accordion/Accordion';
import FlexibleCta from '../components/flexible/Cta';
// import FlexibleCarousel from '../components/flexible/Carousel/Carousel';

const Welcome = () => {

    const history = useHistory();
    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setUpHeader({
            show: false
          }));
      }, [dispatch]);

    return (
        <div style={{'overflow':'hidden', 'width': '100%'}}>
            <header className='header blue-dark welcome-header'>
                <div className='header--inner'>
                    <div className='header--logo' onClick={() => history.push('/')}><Logo /></div>
                    <div className='header--buttons'>
                        {!isAuthenticated &&
                            <Button 
                                className='btn btn-outline white pill'
                                Clicked={() => isAuthenticated ? history.push('/account') : history.push('/login')}
                                text={isAuthenticated ? 'My Account' : 'Log in' }
                            /> 
                        }
                        <Button 
                            className='btn btn-primary purple pill'
                            Clicked={() => isAuthenticated ? history.push('/account') : history.push('/register')}
                            text={isAuthenticated ? 'My Account' : 'Register' }
                        />
                    </div>
                </div>
            </header>

            <section className='welcome-intro'>
                <h1>Icon Doctor App</h1>
                <p>Get access to haematology and oncology related resources, education, events and clinical referral guidelines.</p>
                <div className='welcome-bg-1'></div>
                <div className='welcome-bg-2'></div>
            </section>

            <section className='welcome-modules'>
    
                <FlexibleVideo
                    src='/temp/IDA_Demo_Draft_v2.mp4'
                    offset={true}
                    controls={false}
                    playing={true}
                    playsinline={true}
                    muted={true}
                    loop={true}
                />

                <FlexibleList
                    title='Made for GPs and Specialists like you'
                    description='Icon Doctor App provides GPs and specialists with access to a comprehensive collection of haematology and oncology related resources, education, events and clinical referral guidelines. Users can also access CPD attendance history, manage education preferences and securely communicate with Icon specialists.'
                    items={[
                        {
                            title: 'Referrals',
                            description: 'Refer to an Icon Specialist',
                            icon: 'refer'
                        },
                        {
                            title: 'Education',
                            description: 'Reach your yearly CPD requirements',
                            icon: 'education'
                        },
                        {
                            title: 'Events',
                            description: 'Gain access to exclusive Icon events',
                            icon: 'calendar'
                        },
                        {
                            title: 'News',
                            description: 'Stay up to date with the latest industry news',
                            icon: 'article'
                        }
                    ]}
                    cta={!isAuthenticated ? {
                        label: 'Register',
                        callback: () => history.push('/register')
                    } : null}
                />

                {/* <FlexibleCarousel
                    title={'From your peers'}
                    options={{
                        slidesPerView: 1,
                        spacing: 0,
                        breakpoints: {
                            '(min-width: 520px)': {
                                slidesPerView: 2
                            },
                            '(min-width: 1200px)': {
                                slidesPerView: 3
                            }
                        }
                    }}
                    hasDots={true}
                    items={[
                        {
                            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eget luctus ipsum, sollicitudin elementum massa. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                            image: {
                                src: '/temp/temp_dr.png',
                                alt: ''
                            },
                            name: 'Dr. James Testington',
                            position: 'MBBS (Hons), PhD, FRANZCR'
                        },
                        {
                            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eget luctus ipsum, sollicitudin elementum massa. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                            image: {
                                src: '/temp/temp_dr.png',
                                alt: ''
                            },
                            name: 'Dr. James Testington',
                            position: 'MBBS (Hons), PhD, FRANZCR'
                        },
                        {
                            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eget luctus ipsum, sollicitudin elementum massa. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                            image: {
                                src: '/temp/temp_dr.png',
                                alt: ''
                            },
                            name: 'Dr. James Testington',
                            position: 'MBBS (Hons), PhD, FRANZCR'
                        },
                        {
                            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eget luctus ipsum, sollicitudin elementum massa. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                            image: {
                                src: '/temp/temp_dr.png',
                                alt: ''
                            },
                            name: 'Dr. James Testington',
                            position: 'MBBS (Hons), PhD, FRANZCR'
                        },
                        {
                            text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed eget luctus ipsum, sollicitudin elementum massa. Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
                            image: {
                                src: '/temp/temp_dr.png',
                                alt: ''
                            },
                            name: 'Dr. James Testington',
                            position: 'MBBS (Hons), PhD, FRANZCR'
                        }
                    ]}
                /> */}

                {/* <FlexibleAccordion 
                    title='FAQs'
                    items={[
                        {
                            title: 'Are there any subscription fees?',
                            content: 'Content 1'
                        },
                        {
                            title: 'Can the app be used to keep track of my CPD?',
                            content: 'Content 2'
                        },
                        {
                            title: 'What types of resources are available?',
                            content: 'Content 3'
                        }
                    ]}
                /> */}

                <FlexibleCta
                    title='Get started'
                    list={[
                        'Free to register',
                        'Optimised for Desktop, Tablet or Mobile',
                        'Content tailored to your preferences'
                    ]}
                    image={{
                        src: '/temp/temp_cta.png',
                        alt: 'Desktop app version'
                    }}
                    cta={!isAuthenticated ? {
                        label: 'Register',
                        callback: () => history.push('/register')
                    } : null}
                />

            </section>
        </div>
    );

};
    
export default Welcome;